// Admin active-sessions presence (FCA-6979).

/**
 * Harness FME flag gating the whole feature. Fail-safe OFF: when the flag is
 * absent, off, or the SDK cannot be reached, the menu entry is hidden, the
 * route renders not-found even for a super-admin who typed the URL, AND no
 * heartbeats are emitted, so an unconfigured environment costs nothing.
 */
export const ACTIVE_SESSIONS_FLAG = "active_sessions_page";

/**
 * localStorage key holding the multi-tab heartbeat lease. Multi-tab is a single
 * session server-side (all tabs share one cookie and therefore one
 * `origin_jti`), so having every tab beat would multiply the Cognito
 * `GetUser` cost for no extra information. One tab beats on behalf of all.
 */
export const HEARTBEAT_LEASE_KEY = "fca_presence_hb_lease";

/**
 * A lease older than this many intervals is considered abandoned (the owning
 * tab was closed or throttled), and any other tab may take over. Two intervals
 * plus a margin avoids handing the lease around during normal jitter.
 */
export const LEASE_STALE_INTERVALS = 2.5;

/** Guard rails around the runtime-configurable interval, in seconds. */
export const MIN_HEARTBEAT_SECONDS = 30;
export const MAX_HEARTBEAT_SECONDS = 900;
export const DEFAULT_HEARTBEAT_SECONDS = 60;

/**
 * Jitter fraction applied to every scheduled delay. Without it, everyone who
 * signed in after a deploy would beat in lockstep and hit Cognito in a spike.
 */
export const HEARTBEAT_JITTER_RATIO = 0.2;

/**
 * `gone` exists because sessions are retained rather than deleted once they go
 * quiet: a row that used to vanish now stays and says so. It is a statement
 * about the past, which is why it is styled neutrally instead of as an alarm.
 */
export const PRESENCE_STATES = {
    ACTIVE: "active",
    IDLE: "idle",
    GONE: "gone"
};

/**
 * Which slice of the retained history the list is showing. `live` stays the
 * default so the page keeps answering "who is online right now" without the
 * admin choosing anything; `all` is an explicit opt-in to the archive.
 */
export const SESSION_WINDOWS = {
    LIVE: "live",
    ALL: "all"
};
